import { render, staticRenderFns } from "./FAQMentee.vue?vue&type=template&id=703b5b65&scoped=true&"
import script from "./FAQMentee.vue?vue&type=script&lang=js&"
export * from "./FAQMentee.vue?vue&type=script&lang=js&"
import style0 from "./FAQMentee.vue?vue&type=style&index=0&id=703b5b65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703b5b65",
  null
  
)

export default component.exports